import React from 'react';
import { resolveExportPanelComponent } from './ui/exportPanelRegistry';

const ExportedImagesPanel = ({ 
  exportedImages, 
  showExportedImages, 
  setShowExportedImages,
  allViewsImages = [], // Array of all views' images
  configData,
  onAddToCart,
  isTestMode = true, // Flag to control test mode
  isExporting = false,
  statusMessage = '',
  panelMode = 'custom',
  CustomPanelComponent
}) => {
  // Early exit when hidden (keeps behavior consistent across modes)
  if (!showExportedImages) return null;

  const Panel = resolveExportPanelComponent({ mode: panelMode, customPanelComponent: CustomPanelComponent });

  return (
    <Panel
      exportedImages={exportedImages}
      showExportedImages={showExportedImages}
      setShowExportedImages={setShowExportedImages}
      allViewsImages={allViewsImages}
      configData={configData}
      onAddToCart={onAddToCart}
      isTestMode={isTestMode}
      isExporting={isExporting}
      statusMessage={statusMessage}
    />
  );
};

export default ExportedImagesPanel;
